import React, { useState, useEffect } from "react";
import { Form, Input } from "antd";
import { EyeInvisibleOutlined, EyeOutlined, EyeTwoTone } from "@ant-design/icons";

export default function BasicAuthForm(props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  const validateUsername = (username) => {
    // Username should not be empty and should be at least 3 characters
    return username.trim().length >= 3;
  };

  const validatePassword = (password) => {
    // Password should be at least 6 characters long
    return password.trim().length >= 6;
  };

  // Validate and notify parent about validation status
  useEffect(() => {
    const isUsernameValid = validateUsername(username);
    const isPasswordValid = validatePassword(password);
    const isValid = isUsernameValid && isPasswordValid;

    setUsernameError(!isUsernameValid && username.trim() !== "");
    setPasswordError(!isPasswordValid && password.trim() !== "");

    if (props.onValidationChange) {
      props.onValidationChange(isValid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [username, password]);

  // Initialize values from props when component mounts or props change
  useEffect(() => {
    if (props.connectionData?.authInfo?.parameters) {
      const authParams = props.connectionData.authInfo.parameters;

      const newUsername = authParams.username || "";
      const newPassword = authParams.password || "";

      setUsername(newUsername);
      setPassword(newPassword);

      // Call immediately with the values
      if (props.handleChangeValues) {
        props.handleChangeValues({
          username: newUsername,
          password: newPassword,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.connectionData]);

  const handleChangeUsername = (e) => {
    const newUsername = e.target.value;
    setUsername(newUsername);
    setUsernameError(false);

    // Use the new username value, not the state (which hasn't updated yet)
    props.handleChangeValues({
      username: newUsername,
      password: password,
    });
  };

  const handleChangePassword = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    setPasswordError(false);

    props.handleChangeValues({
      username: username,
      password: newPassword,
    });
  };

  return (
    <div>
      <Form.Item
        style={{ marginBottom: "8px" }}
        label="Basic Auth Username"
        rules={[{ required: true, message: "Please input username!" }]}
        required={true}
        validateStatus={usernameError ? "error" : ""}
        help={usernameError ? "Username must be at least 3 characters long" : ""}
      >
        <Input
          value={username}
          onChange={handleChangeUsername}
          disabled={props.isDisabled || props.isViewOnly}
          placeholder="Enter username"
        />
      </Form.Item>
      <Form.Item
        style={{ marginBottom: "8px" }}
        label="Basic Auth Password"
        rules={[{ required: true, message: "Please input password!" }]}
        required={true}
        validateStatus={passwordError ? "error" : ""}
        help={passwordError ? "Password must be at least 6 characters long" : ""}
      >
        <Input.Password
          value={password}
          onChange={handleChangePassword}
          disabled={props.isDisabled || props.isViewOnly}
          placeholder="Enter password"
          visibilityToggle={!props.isViewOnly && !props.isDisabled}
          iconRender={(visible) => (password.length > 0 ? visible ? <EyeInvisibleOutlined /> : <EyeOutlined /> : null)}
        />
      </Form.Item>
    </div>
  );
}
